import { render, staticRenderFns } from "./ModalDeleteFormItem.vue?vue&type=template&id=48486cde&scoped=true"
import script from "./ModalDeleteFormItem.vue?vue&type=script&lang=js"
export * from "./ModalDeleteFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48486cde",
  null
  
)

export default component.exports